import Slider from 'react-slick';
import ReviweCard from '../ReviweCard';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styled from 'styled-components';
import data from './fakeData.json';

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  pauseOnHover: true,
  fade: true,
  cssEase: 'linear',
  draggable: false
};
const SliderTestimonials = () => {
  return (
    <Wrapper className="wrapper">
      <SliderStyle {...settings}>
        {data.map((item) => {
          return <ReviweCard key={item.testimony} {...item} />;
        })}
      </SliderStyle>
    </Wrapper>
  );
};

export default SliderTestimonials;
const Wrapper = styled.div`
  width: 50%;
  height: 60rem;
  padding-top: 6rem;
`;
const SliderStyle = styled(Slider)`
  .slick-dots li button:before {
    line-height: 0px;
    text-align: center;
    color: #b0b8a7;
    content: '▪';
    font-size: 5rem;
  }
  .slick-dots li.slick-active :before {
    color: #fff;
  }
  .slick-dots li.slick-active button:before {
    opacity: 0.75;
    color: black;
  }
  .slick-dots li button:before {
    color: #b0b8a7;
  }
`;
